(function () {
  "use strict";

  var ENDPOINT = window.ZZ_ANALYTICS_ENDPOINT || "https://app.zekzekmerch.com/api/analytics/events";
  var SCRIPT_VERSION = "20260728-homepage-ac-v1";
  var HOME_EXPERIMENT_ID = "homepage_r2_ac_v1";
  var HOME_EXPERIMENT_STORAGE_KEY = "zekzek_homepage_experiment_homepage_r2_ac_v1";
  var HOME_EXPERIMENT_ATTRIBUTION_KEY = "zekzek_homepage_experiment_attribution_homepage_r2_ac_v1";
  var ANON_KEY = "zekzek_analytics_anon_id_v1";
  var SESSION_KEY = "zekzek_analytics_session_id_v1";
  var pageStartedAt = Date.now();
  var visibleStartedAt = document.visibilityState === "visible" ? Date.now() : 0;
  var activeMs = 0;
  var maxScrollPct = 0;
  var clickCount = 0;
  var ctaClickCount = 0;
  var sentEngagement = false;
  var seenSections = {};

  function newId(prefix) {
    try {
      if (window.crypto && window.crypto.randomUUID) return prefix + "_" + window.crypto.randomUUID();
    } catch (err) {}
    return prefix + "_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
  }

  function storedId(storage, key, prefix) {
    try {
      var existing = storage.getItem(key);
      if (existing) return existing;
      var fresh = newId(prefix);
      storage.setItem(key, fresh);
      return fresh;
    } catch (err) {
      return newId(prefix);
    }
  }

  var anonymousId = storedId(window.localStorage, ANON_KEY, "zka");
  var sessionId = storedId(window.sessionStorage, SESSION_KEY, "zks");

  function homeExperiment() {
    var current = window.ZZ_HOME_EXPERIMENT || {};
    var root = document.documentElement;
    var id = String(current.id || root.getAttribute("data-home-experiment-id") || "");
    var variant = String(current.variant || root.getAttribute("data-home-experiment-variant") || "").toLowerCase();
    if (!variant) {
      try { variant = String(window.localStorage.getItem(HOME_EXPERIMENT_STORAGE_KEY) || "").toLowerCase(); } catch (error) {}
    }
    if (variant && !id) id = HOME_EXPERIMENT_ID;
    if (id !== HOME_EXPERIMENT_ID || ["a", "c"].indexOf(variant) === -1) return {};
    var storedAttribution = {};
    try { storedAttribution = JSON.parse(window.localStorage.getItem(HOME_EXPERIMENT_ATTRIBUTION_KEY) || "{}"); } catch (error) {}
    var currentAttribution = {
      experiment_id: id,
      experiment_variant: variant,
      experiment_qa: Boolean(current.qa || root.getAttribute("data-home-experiment-qa") === "true"),
      experiment_lang: String(storedAttribution.experiment_lang || ""),
      experiment_device: String(storedAttribution.experiment_device || ""),
      experiment_utm_source: String(storedAttribution.experiment_utm_source || ""),
      experiment_utm_campaign: String(storedAttribution.experiment_utm_campaign || ""),
      experiment_assigned_at: String(storedAttribution.experiment_assigned_at || "")
    };
    if (pageType() === "home") {
      var campaign = utmProps();
      currentAttribution.experiment_lang = currentAttribution.experiment_lang || (document.documentElement.getAttribute("lang") || "").toLowerCase();
      currentAttribution.experiment_device = currentAttribution.experiment_device || ((window.innerWidth || 0) <= 1024 ? "mobile" : "desktop");
      currentAttribution.experiment_utm_source = currentAttribution.experiment_utm_source || String(campaign.utm_source || "");
      currentAttribution.experiment_utm_campaign = currentAttribution.experiment_utm_campaign || String(campaign.utm_campaign || "");
      currentAttribution.experiment_assigned_at = currentAttribution.experiment_assigned_at || new Date().toISOString();
      try { window.localStorage.setItem(HOME_EXPERIMENT_ATTRIBUTION_KEY, JSON.stringify(currentAttribution)); } catch (error) {}
    }
    return currentAttribution;
  }

  function productHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function productKey(handle) {
    var value = String(handle || "").toLowerCase();
    if (value.indexOf("standee") !== -1) return "standee";
    if (value.indexOf("sticker") !== -1) return "stickers";
    if (value.indexOf("keychain") !== -1) return "keychain";
    return value;
  }

  function pageType() {
    var path = window.location.pathname;
    if (path === "/" || path === "") return "home";
    if (path.indexOf("/products/") === 0) return "pdp";
    if (path.indexOf("/cart") === 0) return "cart";
    if (path.indexOf("/checkout") === 0) return "checkout";
    if (path.indexOf("/policies/") === 0) return "policy";
    if (path.indexOf("/collections/") === 0) return "collection";
    return "other";
  }

  function pageGroup() {
    var type = pageType();
    var handle = productHandleFromPath();
    if (type === "home") return "home";
    if (type === "cart") return "cart";
    if (type === "pdp") return handle ? "pdp_" + productKey(handle).replace(/s$/, "") : "pdp";
    return type;
  }

  function utmProps() {
    var params = new URLSearchParams(window.location.search);
    var output = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach(function (key) {
      var value = params.get(key);
      if (value) output[key] = value.slice(0, 160);
    });
    return output;
  }

  function isQaMode() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get("zk_qa") === "1" || params.get("qa") === "1";
    } catch (err) {
      return false;
    }
  }

  function baseProperties(extra) {
    var handle = productHandleFromPath();
    return Object.assign({
      page_type: pageType(),
      page_group: pageGroup(),
      path: window.location.pathname,
      title: document.title || "",
      lang: (document.documentElement.getAttribute("lang") || "").toLowerCase(),
      product_handle: handle,
      product: productKey(handle),
      viewport_width: window.innerWidth || 0,
      viewport_height: window.innerHeight || 0,
      max_scroll_pct: Math.round(maxScrollPct),
      click_count: clickCount,
      cta_click_count: ctaClickCount
    }, utmProps(), homeExperiment(), { tracker_version: SCRIPT_VERSION }, extra || {});
  }

  function send(eventName, properties) {
    var payload = JSON.stringify({
      event_name: eventName,
      occurred_at: new Date().toISOString(),
      source: isQaMode() ? "qa-storefront" : "storefront",
      session_id: sessionId,
      anonymous_id: anonymousId,
      product_handle: productHandleFromPath(),
      page_url: window.location.href,
      referrer: document.referrer || "",
      properties: baseProperties(properties)
    });

    try {
      fetch(ENDPOINT, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: payload
      }).catch(function () {});
    } catch (err) {
    }
  }

  function updateActiveTime() {
    if (visibleStartedAt) {
      activeMs += Date.now() - visibleStartedAt;
      visibleStartedAt = Date.now();
    }
  }

  function updateScroll() {
    var doc = document.documentElement;
    var body = document.body;
    var scrollTop = window.scrollY || doc.scrollTop || body.scrollTop || 0;
    var height = Math.max(
      body.scrollHeight || 0,
      doc.scrollHeight || 0,
      body.offsetHeight || 0,
      doc.offsetHeight || 0
    );
    var viewport = window.innerHeight || doc.clientHeight || 0;
    var denominator = Math.max(1, height - viewport);
    var pct = Math.min(100, Math.max(0, (scrollTop / denominator) * 100));
    if (pct > maxScrollPct) maxScrollPct = pct;
  }

  function sendEngagement(force) {
    updateActiveTime();
    updateScroll();
    if (!force && activeMs < 1000 && maxScrollPct < 5 && clickCount === 0) return;
    if (sentEngagement && !force) return;
    sentEngagement = true;
    send("zk_site_page_engaged", {
      total_ms: Date.now() - pageStartedAt,
      active_ms: Math.max(0, Math.round(activeMs)),
      max_scroll_pct: Math.round(maxScrollPct)
    });
  }

  function appendEditorIds(url) {
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.hostname !== "app.zekzekmerch.com" || parsed.pathname.indexOf("/editor") !== 0) return url;
      parsed.searchParams.set("zk_cid", anonymousId);
      parsed.searchParams.set("zk_sid", sessionId);
      if (!parsed.searchParams.get("zk_from")) parsed.searchParams.set("zk_from", pageGroup());
      var experiment = homeExperiment();
      if (experiment.experiment_id && experiment.experiment_variant) {
        parsed.searchParams.set("zk_exp", experiment.experiment_id);
        parsed.searchParams.set("zk_var", experiment.experiment_variant);
        if (experiment.experiment_qa) parsed.searchParams.set("zk_qa", "1");
        if (experiment.experiment_lang) parsed.searchParams.set("zk_lang", experiment.experiment_lang);
        if (experiment.experiment_device) parsed.searchParams.set("zk_device", experiment.experiment_device);
        if (experiment.experiment_utm_source) parsed.searchParams.set("zk_utm_source", experiment.experiment_utm_source);
        if (experiment.experiment_utm_campaign) parsed.searchParams.set("zk_utm_campaign", experiment.experiment_utm_campaign);
        if (experiment.experiment_assigned_at) parsed.searchParams.set("zk_exp_at", experiment.experiment_assigned_at);
      }
      return parsed.toString();
    } catch (err) {
      return url;
    }
  }

  function targetKind(url) {
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.hostname === "app.zekzekmerch.com" && parsed.pathname.indexOf("/editor") === 0) return "editor";
      if (parsed.pathname.indexOf("/products/") === 0) return "pdp";
      if (parsed.pathname.indexOf("/cart") === 0) return "cart";
      if (parsed.hostname !== window.location.hostname) return "external";
    } catch (err) {}
    return "internal";
  }

  function bindClicks() {
    document.addEventListener("click", function (event) {
      clickCount += 1;
      var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;
      if (!link) return;
      var href = link.getAttribute("href") || "";
      var kind = targetKind(href);
      if (["editor", "pdp", "cart"].indexOf(kind) === -1) return;

      ctaClickCount += 1;
      var text = (link.textContent || "").replace(/\s+/g, " ").trim().slice(0, 120);
      var trackedHref = kind === "editor" ? appendEditorIds(link.href || href) : (link.href || href);
      if (kind === "editor" && trackedHref && trackedHref !== link.href) link.href = trackedHref;

      send("zk_site_cta_clicked", {
        cta_id: link.getAttribute("data-zz-analytics-id") || text || kind,
        cta_text: text,
        destination_type: kind,
        target_url: trackedHref,
        target_path: (function () {
          try { return new URL(trackedHref, window.location.href).pathname; } catch (err) { return ""; }
        })()
      });
    }, true);
  }

  function observeSections() {
    if (!("IntersectionObserver" in window)) return;
    var candidates = Array.prototype.slice.call(document.querySelectorAll("[data-zz-analytics-section], .zz-page-release section[id], main section[id]"));
    if (!candidates.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
        var node = entry.target;
        var id = node.getAttribute("data-zz-analytics-section") || node.id || node.className || "section";
        id = String(id).slice(0, 120);
        if (seenSections[id]) return;
        seenSections[id] = true;
        send("zk_site_section_viewed", {
          section_id: id,
          section_text: (node.querySelector("h1,h2,h3")?.textContent || "").replace(/\s+/g, " ").trim().slice(0, 160)
        });
      });
    }, { threshold: [0.35] });
    candidates.slice(0, 40).forEach(function (node) { observer.observe(node); });
  }

  window.addEventListener("scroll", updateScroll, { passive: true });
  window.addEventListener("resize", updateScroll, { passive: true });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      sendEngagement(true);
      visibleStartedAt = 0;
    } else if (!visibleStartedAt) {
      visibleStartedAt = Date.now();
    }
  });
  window.addEventListener("pagehide", function () { sendEngagement(true); });

  bindClicks();
  observeSections();
  updateScroll();
  send("zk_site_page_viewed");
})();
